module.exports = __webpack_public_path__ + "ecff883fbe72ede97ed05ef91a9f48.png";